import { render, staticRenderFns } from "./Passenger.vue?vue&type=template&id=faa40856&scoped=true"
import script from "./Passenger.vue?vue&type=script&lang=js"
export * from "./Passenger.vue?vue&type=script&lang=js"
import style0 from "./Passenger.vue?vue&type=style&index=0&id=faa40856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa40856",
  null
  
)

export default component.exports